import { useEffect, useState } from "react";

export function useNetwork() {
    const [isOnline, setIsOnline] = useState(globalThis.navigator.onLine);
    const updateNetwork = () => {
      setIsOnline(globalThis.navigator.onLine);
    };
    useEffect(() => {
      globalThis.addEventListener("offline", updateNetwork);
      globalThis.addEventListener("online", updateNetwork);
      return () => {
        globalThis.removeEventListener("offline", updateNetwork);
        globalThis.removeEventListener("online", updateNetwork);
      };
    });
    return isOnline;
  }
  